import * as actions from "./actionTypes";
import * as config from "config";


export function validateBvn(params, token) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl + "/wallet",
            url: config.apiValidateBvn,
            method: "post",
            data: params,
            onStart: actions.VALIDATE_BVN_START,
            onSuccess: actions.VALIDATE_BVN,
            onError: actions.VALIDATE_BVN_FAILED,
        },
    }
}

export function resetValidateBvn() {
    return {
        type: actions.VALIDATE_BVN_RESET,
        payload: {},
    }
}

export function sendBvnOtp(params, token) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl + "/wallet",
            url: config.apiSendBvnOtp,
            method: "post",
            data: params,
            onStart: actions.SEND_BVN_OTP_START,
            onSuccess: actions.SEND_BVN_OTP,
            onError: actions.SEND_BVN_OTP_FAILED,
        },
    }
}

export function resetSendBvnOtp() {
    return {
        type: actions.SEND_BVN_OTP_RESET,
        payload: {},
    }
}

export function validateBvnOtp(params, token) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiWalletBaseUrl + "/wallet",
            url: config.apiValidateBvnOtp,
            method: "post",
            data: params,
            onStart: actions.VALIDATE_BVN_OTP_START,
            onSuccess: actions.VALIDATE_BVN_OTP,
            onError: actions.VALIDATE_BVN_OTP_FAILED,
        },
    }
}

export function resetValidateBvnOtp() {
    return {
        type: actions.VALIDATE_BVN_OTP_RESET,
        payload: {},
    }
}
